export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./classroomHeader.vue?vue&type=template&id=2121188e&"


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/classroomHeader.vue?vue&type=template&id=2121188e&
// module id = null
// module chunks = 